/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LevelConfigResponse } from './LevelConfigResponse';
import {
    LevelConfigResponseFromJSON,
    LevelConfigResponseFromJSONTyped,
    LevelConfigResponseToJSON,
    LevelConfigResponseToJSONTyped,
} from './LevelConfigResponse';

/**
 * 
 * @export
 * @interface GetLevelConfigsResponse
 */
export interface GetLevelConfigsResponse {
    /**
     * 
     * @type {Array<LevelConfigResponse>}
     * @memberof GetLevelConfigsResponse
     */
    levelConfigs: Array<LevelConfigResponse>;
}

/**
 * Check if a given object implements the GetLevelConfigsResponse interface.
 */
export function instanceOfGetLevelConfigsResponse(value: object): value is GetLevelConfigsResponse {
    if (!('levelConfigs' in value) || value['levelConfigs'] === undefined) return false;
    return true;
}

export function GetLevelConfigsResponseFromJSON(json: any): GetLevelConfigsResponse {
    return GetLevelConfigsResponseFromJSONTyped(json, false);
}

export function GetLevelConfigsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLevelConfigsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'levelConfigs': ((json['levelConfigs'] as Array<any>).map(LevelConfigResponseFromJSON)),
    };
}

export function GetLevelConfigsResponseToJSON(json: any): GetLevelConfigsResponse {
    return GetLevelConfigsResponseToJSONTyped(json, false);
}

export function GetLevelConfigsResponseToJSONTyped(value?: GetLevelConfigsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'levelConfigs': ((value['levelConfigs'] as Array<any>).map(LevelConfigResponseToJSON)),
    };
}

